/**
 * Shared style fragments.
 *
 * Anything that defines how the portal looks — glass, cards, modals, buttons —
 * belongs here rather than being copied into components, so the pieces cannot
 * drift apart. Per-instance layout (display, gap, width, spacing) stays inline.
 *
 * Colours always come from the CSS variables in theme/themes.ts: the portal has
 * 12 themes, 6 of them light, so a hardcoded colour breaks half of them.
 */

/** Frosted panel background used across the portal. Radius is set by the caller. */
export const glassSx = {
  background: 'var(--glass-bg)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border: '1px solid var(--glass-border)',
} as const;

/** Standard card: glass with the portal's card radius. */
export const cardSx = {
  ...glassSx,
  borderRadius: '14px',
} as const;
